import { getString } from 'firebase/remote-config';
import { useEffect, useState } from 'react';

import { useRemoteConfig } from './use-remote-config';

type RemoteConfigNumberKey = 'min_card_img_dimension';

/** Get a numeric remote config value  */
export const useRemoteConfigNumber = (key: RemoteConfigNumberKey, defaultValue: number): number => {
  const [value, setValue] = useState<number>(defaultValue);
  const remoteConfig = useRemoteConfig();

  useEffect(() => {
    if (remoteConfig) {
      const valueAsString = getString(remoteConfig, key);
      if (valueAsString) {
        const candidate = parseFloat(valueAsString);
        setValue(isNaN(candidate) ? defaultValue : candidate);
      } else {
        setValue(defaultValue);
      }
    }
  }, [key, remoteConfig, defaultValue]);

  return value;
};
